export default __webpack_public_path__ + "static/media/46.94db298a.jpg";